var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.75,0,0,10.75,0,24s10.75,24,24,24,24-10.75,24-24S37.25,0,24,0ZM17.91,13.48l7.26,12.57h-14.52l7.26-12.57ZM13.59,37.08c-1.22,0-2.33-.69-2.89-1.78l-2.7-4.67h19.81l3.72,6.45H13.59ZM39.36,32.62l-2.56,4.43L20.56,8.92h5.56c1.2,0,2.3.66,2.85,1.72l10.52,18.28c.32.51.52,1.11.52,1.75h0c0,.73-.14,1.11-.64,1.96Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.9c278250ece8c93d22a4f937428eafa9.svg";
export { ForwardRef as ReactComponent };